import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '产品服务', path: '/categories' },
  { name: '新闻动态', path: '/articles' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 cursor-pointer whitespace-nowrap">
            <span className={`text-xl md:text-2xl font-bold tracking-tight ${scrolled || !isHome ? 'text-foreground-950' : 'text-white'}`}>
              MJHL
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? scrolled || !isHome
                      ? 'text-primary-600'
                      : 'text-white border-b-2 border-white'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-600'
                      : 'text-white/80 hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer ${
                scrolled || !isHome
                  ? 'border border-foreground-300 text-foreground-700 hover:border-primary-500 hover:text-primary-600'
                  : 'border border-white/40 text-white hover:border-white hover:text-white'
              }`}
            >
              联系我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-2 px-4 py-2 text-sm font-medium rounded-md text-center border border-foreground-300 text-foreground-700 hover:border-primary-500 hover:text-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              联系我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}